import { Bookmark } from '../../store/files/bookmarks/bookmarks.types';
import { useSearchInputBase } from '../StaticComponents/SearchInput/SearchInput.hooks';

export const useSearchBookmarkInput = (options: Bookmark[]) =>
  useSearchInputBase<Bookmark>(options, (el) => el.Name!);
